// src/index.js

import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRouter from './routes/AppRouter';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(<AppRouter />);
